import { type AppState } from 'src/redux/app/app.store'

export const selectVehicleModels = (state: AppState) => state.vehicleModel.vehicleModels
